import { Component, TemplateRef, contentChild, input, model } from '@angular/core';
import { toDisplayLabel } from '../../utils/label.util';

export interface AccordionPanel {
  header: string;
  icon?: string;
  disabled?: boolean;
  content?: string;
}

@Component({
  selector: 'app-primeng-accordion',
  templateUrl: './primeng-accordion.component.html',
  styleUrls: ['./primeng-accordion.component.scss'],
  standalone: false,
})
export class PrimengAccordionComponent {
  panels = input<AccordionPanel[]>([]);
  value = model<any>('');
  multiple = input<boolean>(false);
  styleClass = input<string>('');
  expandIcon = input<string>('pi pi-chevron-right');
  collapseIcon = input<string>('pi pi-chevron-down');

  /** Custom panel content template. Use <ng-template #panelContent>...</ng-template>. */
  contentTemplate = contentChild<TemplateRef<any>>('panelContent');

  /** Custom panel header template. Use <ng-template #panelHeader>...</ng-template>. */
  headerTemplate = contentChild<TemplateRef<any>>('panelHeader');

  handleValueChange(val: any): void {
    this.value.set(val ?? '');
  }

  trackByHeader(_index: number, panel: AccordionPanel): string {
    return toDisplayLabel(panel?.header);
  }

  /** Safe panel label - never renders "[object Object]". */
  headerLabel(panel: AccordionPanel): string {
    return toDisplayLabel(panel?.header);
  }
}
